import { memo } from 'react';

const StepBusinessName = memo(({ businessName, onChange, canProceed, onNext }) => (
  <div className="animate-fadeIn">
    <p className="text-xs font-sans font-medium tracking-widest uppercase mb-2" style={{ color: '#C9A84C', letterSpacing: '0.2em' }}>
      Step 1 of 3
    </p>
    <h2 className="font-serif text-2xl font-bold mb-2" style={{ color: "inherit" }}>
      What&apos;s your business called?
    </h2>
    <p className="font-sans text-sm mb-6" style={{ color: 'inherit', opacity: 0.5 }}>
      This will be the name featured on your site.
    </p>
    <input
      type="text"
      value={businessName}
      onChange={(e) => onChange(e.target.value)}
      placeholder="e.g. Luna & Light Photography"
      className="w-full px-5 py-3.5 rounded-xl text-sm font-sans border outline-none transition-all focus:border-gh-gold"
      style={{ background: 'rgba(128,128,128,0.08)', borderColor: 'rgba(128,128,128,0.15)', color: 'inherit' }}
      data-testid="demo-business-name-input"
      autoFocus
      onKeyDown={(e) => e.key === 'Enter' && canProceed && onNext()}
    />
  </div>
));

StepBusinessName.displayName = 'StepBusinessName';
export default StepBusinessName;
